import { injToken } from '@shared/data/token'
import { IS_DEVNET, IS_TESTNET } from '@shared/utils/constant'
import { MarketCategoryType } from '@/types'
import type { UiMarketWithToken } from '@/types'

export interface UnTradableMarket {
  slug: string
}

export const marketsToHideFromSelection: string[] = []

export const rwaMarketsInStocks: string[] = [
  '0x0160a0c8ecbf5716465b9fc22bceeedf6e92dcdc688e823bbe1af3b22a84e5b5', // XAU-USDT-PERP
  '0xedc48ec071136eeb858b11ba50ba87c96e113400e29670fecc0a18d588238052' // XAG-USDT-PERP
]

export const betaMarketSlugs = [] as string[]
export const excludedPriceDeviationSlugs = [] as string[]

export const deprecatedMarkets =
  IS_DEVNET || IS_TESTNET ? [] : ([] as Array<UiMarketWithToken>)

export const QUOTE_DENOMS_TO_SHOW_USD_VALUE: string[] = [injToken.denom]

export const SETTLED_PERP_MARKETS_LAST_PRICE = {} as {
  [key: string]: undefined | { price?: string; denom?: string }
}

export const SEDA_MARKET_IDS = [
  '0x5c8fe180ff7b8c986d3d003f7e758b34db61feaef179a657699b212d62846887', // PLTR-USDT-PERP
  '0x1e8369b298705c468c1a313a729bae0dbd4410587465cc69276bf8ba4e0231c1' // NVDA-USDT-PERP
]

export const MARKET_CATEGORIES_TO_DISPLAY: MarketCategoryType[] = [
  MarketCategoryType.All,
  MarketCategoryType.Favorites,
  MarketCategoryType.Spot,
  MarketCategoryType.Perps,
  MarketCategoryType.Trending,
  MarketCategoryType.Injective,
  MarketCategoryType.Layer1,
  MarketCategoryType.Stocks,
  MarketCategoryType.AI,
  MarketCategoryType.DeFi
]
